module.exports = __webpack_public_path__ + "static/media/Share.64e216d6.svg";